import { useCallback, useEffect, useRef, useState } from 'react';

/**
 *
 * @deprecated This hook is deprecated and will be removed in a future version.
 */
export const useHover = () => {
  const [hovered, setHovered] = useState(false);
  const node = useRef<HTMLElement | null>(null);

  const handleMouseOver = () => setHovered(true);
  const handleMouseOut = () => setHovered(false);

  const removeHoverListeners = useCallback(() => {
    if (!node.current) return;

    node.current.removeEventListener('mouseover', handleMouseOver);
    node.current.removeEventListener('mouseout', handleMouseOut);
  }, []);

  const addHoverListeners = useCallback(
    (ele: HTMLElement | null) => {
      if (!ele) return;
      node.current = ele;
      removeHoverListeners();

      ele.addEventListener('mouseover', handleMouseOver);
      ele.addEventListener('mouseout', handleMouseOut);
    },
    [removeHoverListeners]
  );

  useEffect(() => {
    return removeHoverListeners;
  }, [removeHoverListeners]);

  return [addHoverListeners, hovered] as const;
};
